/* eslint-disable @angular-eslint/no-outputs-metadata-property */
/* eslint-disable @angular-eslint/component-selector */
/* eslint-disable @angular-eslint/no-inputs-metadata-property */
/* eslint-disable @typescript-eslint/no-unsafe-declaration-merging */

import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { DcrCheckbox } from '@diekeure/dcr-components';
import { BaseProxyComponent } from '../lib/base.proxy';
import { ProxyWebComponent } from './../lib/utils';
// DCR Component
export declare interface DcrCheckboxComponent extends DcrCheckbox {
  checkedChange: EventEmitter<CustomEvent<boolean>>;
}

@ProxyWebComponent()
@Component({
    selector: `
    dcr-checkbox[formControl],
    dcr-checkbox[formControlName],
    dcr-checkbox[ngModel]
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: '<ng-content></ng-content>',
    inputs: [
        'checked',
        'value',
        'disabled',
        'required',
        'label',
        'indeterminate',
        'invalid',
        'validationMessage',
        'supportingText',
    ],
    standalone: false
})
export class DcrCheckboxComponent extends BaseProxyComponent {
  @Output() checkedChange: EventEmitter<CustomEvent<boolean>> = new EventEmitter<CustomEvent<boolean>>();
}
